<form [formGroup]="productForm" style="width: 22rem;" (ngSubmit)="onFormSubmit()">

  <!-- input names -->
  <div class="md-form">
    <label for="name" class="font-weight-light">Name</label>
    <input type="text" id="name" formControlName="name" class="form-control" mdbInputDirective>
    
  </div>

  <div class="md-form">
    <label for="min" class="font-weight-light">Min Limit</label>
    <input type="number" id="min" formControlName="min" class="form-control" mdbInputDirective>
    
  </div>

  <div class="md-form">
    <label for="max" class="font-weight-light">Max Limit</label>
    <input type="number" id="max" formControlName="max" class="form-control" mdbInputDirective>
    
  </div>

  <div class="md-form">
    <label for="max_limit_approved" class="font-weight-light">Max Limit Approved</label>
    <input type="number" id="max_limit_approved" formControlName="max_limit_approved" class="form-control" mdbInputDirective>
    
  </div>

  <div class="md-form">
    <label for="weeks" class="font-weight-light">Weeks</label>
    <input type="number" id="weeks" formControlName="weeks" class="form-control" mdbInputDirective>
    
  </div>

  <div class="md-form">
    <label for="interest_rate" class="font-weight-light">Interest Rate</label>
    <input type="number" id="interest_rate" formControlName="interest_rate" class="form-control" mdbInputDirective>
    
  </div>

  <div class="md-form">
    <label for="late_fee_amount" class="font-weight-light">Late Fee</label>
    <input type="number" id="late_fee_amount" formControlName="late_fee_amount" class="form-control" mdbInputDirective>
    
  </div>

  <div class="md-form">
    <label for="contract_id" class="font-weight-light">Contract</label>
    <select id="contract_id" formControlName="contract_id" class="form-control">
      <option value="">Select Contract</option>
      <option *ngFor="let contract of contractList" [value]="contract.id">
        {{ contract.name }}
      </option>
    </select>
  </div>

  <div class="md-form">
    <label for="eu_form_id" class="font-weight-light">EU Form</label>
    <select id="eu_form_id" formControlName="eu_form_id" class="form-control">
      <option value="">Select EU Form</option>
      <option *ngFor="let euForm of euFormList" [value]="euForm.id">
        {{ euForm.name }}
      </option>
    </select>
  </div>

  <div class="text-center py-4 mt-3">
    <button class="btn btn-cyan waves-light" type="submit" [disabled]="productForm.invalid" mdbWavesEffect>{{product_id ? 'Edit' : 'Create' }}</button>
  </div>

</form>